import Cookies from 'js-cookie'

import type { AxiosError } from 'axios'
import { guestExternalMeeting, joinExternalMeeting } from 'api/meetings'
import { useQuery } from 'services/query'
import { MEETING_UNAVAILABLE_ROUTE } from 'globalConstants'

const isMeetingGone = (error: AxiosError) => {
  const status = error.response?.status

  return !!status && status >= 400 && status < 500
}

export const useGuestMeetingAdmission = (code: string) => {
  const visit = new URLSearchParams(window.location.search).get('visit') ?? undefined

  const { data, error, refetch } = useQuery({
    queryKey: ['external-meeting-admission', code],
    queryFn: () =>
      Cookies.get('session') ? joinExternalMeeting(code, visit) : guestExternalMeeting(code, visit),
    onError: (requestError: AxiosError) => {
      if (isMeetingGone(requestError)) {
        window.location.replace(MEETING_UNAVAILABLE_ROUTE)
      }
    }
  })

  return {
    admission: data ?? null,
    isUnreachable: !!error && !isMeetingGone(error),
    retry: refetch
  }
}
